export const contentTableConfig = {
  title: '文章列表',
  propList: [
    { prop: 'question', label: '标题', minWidth: '80' },
    { prop: 'details', label: '文章内容', minWidth: '60', slotName: 'details' },
    { prop: 'cover', label: '封面', minWidth: '60', slotName: 'cover' },
    {
      prop: 'updatedTime',
      label: '更新时间',
      minWidth: '50',
      slotName: 'updatedTime'
    },
    {
      label: '操作',
      minWidth: '60',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
